module.exports = require("@nrwl/workspace");